<template>
	<div class="phone-prefix-input-container">
		<div class="phone-prefix-input" @click="active = true">
			<img v-if="currentCountry" :src="'https://img.qromo.io/img/lang/'+currentCountry.file_name">
			<div class="prefix">{{ currentCountry ? currentCountry.prefix_number : '' }}</div>
		</div>
		<AppBottomSheet id="bottom-sheet-prefix" :forceWidth="bottomSheetWidth" :active="active" @toggling-popup="togglingSheet" >
			<div class="phones-container" v-if="activeDelayed">
				<div class="section-title"><div class="title">{{ getString('phone_country_code') }}</div></div>
				<div class="phone-list-container">
					<div class="phone-item" v-for="country in countries" @click="clickCountry(country)" :class="{selected: currentCountryId === country.country_id}">
						<div class="phone-name">{{ country.key_name+" ("+country.prefix_number+")" }}</div>
						<div class="phone-icon"><img :src="'https://img.qromo.io/img/lang/'+country.file_name"></div>
					</div>
				</div>
			</div>
		</AppBottomSheet>
	</div>
</template>

<script>
import AppBottomSheet from "@/shared/components/AppBottomSheet.vue";
import {useLanguageStore} from "@/shared/stores";
import WindowWidth from "@/console-new/mixins/WindowWidth";

export default {
	setup() {
		let languageStore = useLanguageStore();
		return {getString: languageStore.getString}
	},
	name: "AppPhonePrefix",
	components: {AppBottomSheet},
	mixins: [WindowWidth],
	emits: ['choose-prefix'],
	data() {
		return {
			active: false,
			activeDelayed: false,
			countries: typeof countries !== 'undefined' ? countries : [],
			currentCountryId: null,
		}
	},
	computed: {
		bottomSheetWidth() {
			if(this.windowWidth < 550) {
				return "100%";
			} else if(this.windowWidth < 768) {
				return "550px";
			} else if(this.windowWidth < 1080) {
				return "720px";
			} else if(this.windowWidth < 1440) {
				return "960px";
			} else {
				return "1280px";
			}
		},
		currentCountry() {
			if(this.currentCountryId) {
				return this.countries.find(country => country.country_id === this.currentCountryId);
			} else {
				return this.getDefaultCountry();
			}
		}
	},
	methods: {
		getDefaultCountry() {
			if(typeof COUNTRY !== 'undefined') {
				let findResult = this.countries.find(country => country.code && country.code === COUNTRY);
				if(findResult) {
					return findResult;
				}
			}
			if(this.countries.length > 0) {
				return this.countries[0];
			}
			return null;
		},
		togglingSheet(isOpen) {
			if(!isOpen) {
				this.active = false;
				setTimeout(() => {
					this.activeDelayed = false;
				}, 500);
			} else {
				this.activeDelayed = true;
			}
		},
		clickCountry(country) {
			this.$emit('choose-prefix', country.country_id);
			this.currentCountryId = country.country_id;
			this.active = false;
		}
	},
	mounted() {
		this.currentCountryId = this.currentCountry ? this.currentCountry.country_id : null;
	}
}
</script>

<style lang="scss">
#bottom-sheet-prefix {
	background-color: $alpha_4;
	backdrop-filter: blur(6px);
	-webkit-backdrop-filter: blur(6px);
	transition: visibility 0.5s ease-in-out, opacity 0.5s ease-in-out, backdrop-filter 0.5s ease 0.3s, -webkit-backdrop-filter 0.5s ease 0.3s;

	&.hidden {
		opacity: 0;
		backdrop-filter: blur(0px);
		-webkit-backdrop-filter: blur(0px);
		background-color: $alpha_4;
	}

	.bottom-sheet {
		padding: 0;
		background: var(--color-bg);
		border-radius: 26px 26px 0 0;

		.bottom-sheet-measurer {
			border-radius: 26px 26px 0 0;
		}
	}
}
</style>

<style scoped lang="scss">
.phone-prefix-input {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	background: var(--color-bg);
	border-radius: 13px;
	padding: 0 8px;
	cursor: pointer;
	height: 100%;

	img {
		width: 18px;
		height: 18px;
		margin-right: 4px;
		border-radius: 13px;
	}

	.prefix {
		font-size: 12px;
		line-height: 14px;
		color: #000;
	}
}

.phones-container {
	display: flex;
	flex-direction: column;
	padding: 10px 20px;

	.section-title {
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		background-color: $alpha_4;
		box-shadow: inset 4px 4px 10px -3px rgba(0, 0, 0, 0.1);
		border-radius: 13px;
		padding: 10px 20px;
		margin-bottom: 10px;

		.title {
			font-size: 26px;
			color: #000;
			@include truncateString();
		}

	}


	.phone-list-container {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		flex-wrap: wrap;
		--gap: 8px;
		gap: var(--gap);

		.phone-item {
			--columns: 4;
			width: calc((100% / var(--columns)) - var(--gap) + (var(--gap) / var(--columns)));
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			padding: 4px 8px;
			cursor: pointer;
			background-color: $alpha_4;
			border-radius: 13px;
			box-shadow: var(--theme-box-shadow-null);
			transition: background-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

			@media (max-width: 1080px) {
				--columns: 3;
			}

			@media (max-width: 768px) {
				--columns: 2;
			}

			@media (max-width: 400px) {
				--columns: 1;
			}

			.phone-name {
				font-size: 12px;
				line-height: 14px;
				color: #000;
				@include truncateString();
				transition: color 0.2s ease-in-out;
			}

			.phone-icon {
				width: 16px;
				height: 16px;

				img {
					width: 100%;
					height: 100%;
					object-fit: contain;
					transition: box-shadow 0.2s ease-in-out;
					box-shadow: 0 0 0 1px rgba(255, 255, 255, 0);
					border-radius: 13px;
				}
			}

			&:hover {
				box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.5);
			}

			&.selected {
				background-color: var(--color-primary);

				.phone-name {
					color: var(--color-bg);
				}

				.phone-icon {
					img {
						box-shadow: 0 0 0 1px rgba(255, 255, 255, 1);
					}
				}
			}
		}
	}
}
</style>